import { NO_VALID_EMAIL_AVAILABILITY } from '@/js/helpers/globalConst';

import ParamsLocalStorage from '@/js/utils/ParamsLocalStorage';
import DigitalData from '@/js/helpers/digitalData';

import {
  userLogin,
  getUserInfo,
  userRegister,
  userCheckEmailAvailability,
  userCheckProblem,
} from '@/js/repositories/User';

export default {
  getUserSession({ commit, dispatch }) {
    const html = document.querySelector('html');
    const isAuthorized = Boolean(html.dataset.authorized);

    if (isAuthorized) {
      commit('setLoadingFlags', { name: 'getUserSession', bool: true }, { root: true });

      getUserInfo()
        .then(({ result: profile }) => {
          commit('setIsAuthorized', true);
          commit('setUserData', {
            email: profile.email,
            emailInitial: profile.email,
            secondName: profile.secondName,
            firstName: profile.firstName,
            lastName: profile.lastName,
            phone: profile.phone,
            phoneMobile: profile.phoneMobile,
          });
          // установим дефолтный номер телефона из профиля
          commit('setUserData', {
            phoneInitial: profile.phone,
          });
          commit('setCanFullChangeProfile', profile.canFullEdit === 'Y');
        })
        .catch(() => {
          commit('setIsAuthorized', false);
          dispatch('checkout/initialOrderNotAuth', null, { root: true });
        })
        .finally(() => {
          commit('setLoadingFlags', { name: 'getUserSession', bool: false }, { root: true });
        });
    } else {
      dispatch('checkout/initialOrderNotAuth', null, { root: true });
      const emailLocal = ParamsLocalStorage.getLocalItem('orderMake') || '';
      if (typeof emailLocal === 'string' && emailLocal.length) {
        commit('setEmailUser', emailLocal);
      }
    }
  },
  async checkEmailAvailability({ commit }, email) {
    commit('setLoadingFlags', { name: 'checkEmailAvailability', bool: true }, { root: true });

    return new Promise((resolve, reject) => {
      userCheckEmailAvailability(email)
        .then(() => {
          resolve(true);
        })
        .catch((e) => {
          if (e.code && e.code === NO_VALID_EMAIL_AVAILABILITY) {
            reject(e.message);
          }
          resolve(false);
        })
        .finally(() => {
          commit('setLoadingFlags', { name: 'checkEmailAvailability', bool: false }, { root: true });
        });
    });
  },
  async authorization({ commit }, payload) {
    const {
      login,
      password,
      captchaToken,
      captchaAction,
      captchaVersion,
    } = payload;
    commit('setLoadingFlags', { name: 'authorization', bool: true }, { root: true });

    return new Promise((resolve, reject) => {
      userLogin({
        login,
        password,
        captchaToken,
        captchaAction,
        captchaVersion,
      })
        .then(({ result: profile }) => {
          // удаляем капчу со страницы если она есть
          const recaptchaContainer = document.querySelector('.js-recaptcha-container');
          if (recaptchaContainer && recaptchaContainer.firstChild) {
            recaptchaContainer.removeChild(recaptchaContainer.firstChild);
          }
          // сохраняем все данные
          commit('setUserData', {
            email: profile.email,
            secondName: profile.secondName,
            firstName: profile.firstName,
            lastName: profile.lastName,
            phone: profile.phone,
            phoneMobile: profile.phoneMobile,
          });
          // установим дефолтный номер телефона из профиля
          commit('setUserData', {
            phoneInitial: profile.phone,
          });
          commit('setCanFullChangeProfile', profile.canFullEdit === 'Y');
          commit('setIsAuthorized', true);
          ParamsLocalStorage.deleteLocalItem('orderMake');
          resolve();
        })
        .catch(e => reject(e))
        .finally(() => {
          commit('setLoadingFlags', { name: 'authorization', bool: false }, { root: true });
        });
    });
  },
  registration({ state, commit }) {
    commit('setLoadingFlags', { name: 'registration', bool: true }, { root: true });

    return userRegister({
      email: state.email,
      name: state.name,
      lastName: state.lastName,
      phone: state.phone,
      phoneMobile: state.phoneMobile,
      unsubscribed: state.isAgreeWithData ? 0 : 1,
    })
      .then(({ result: profile }) => {
        // отправляем событие регистрации пользователя
        DigitalData.pushEvent(['user', profile, 'book24'], 'changes');
        DigitalData.pushEvent({
          category: 'Auth',
          name: 'Registered',
          user: {
            subscriptions: [{
              type: 'email',
              isSubscribed: true,
            }],
            authToken: profile.authToken,
          },
        });

        ParamsLocalStorage.deleteLocalItem('orderMake');
        commit('setIsAuthorized', true);
      })
      .catch(error => Promise.reject(error.message))
      .finally(() => {
        commit('setLoadingFlags', { name: 'registration', bool: false }, { root: true });
      });
  },
  checkUserProblem({ state, commit, rootState }) {
    commit('setLoadingFlags', { name: 'checkUserProblem', bool: true }, { root: true });

    return userCheckProblem({
      email: state.email,
      name: state.fullName,
      phone: state.phone,
      isPreOrder: rootState.checkout.preOrderMode,
    })
      .then(({ result }) => result.needProof)
      .catch(error => Promise.reject(error))
      .finally(() => {
        commit('setLoadingFlags', { name: 'checkUserProblem', bool: false }, { root: true });
      });
  },
};
